import i18n from 'i18next';
import { Provider as StoreProvider } from 'react-redux';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import App from './App';
import { store } from './store';
import { setupAxios } from './shared/utils/axios';

const history = createBrowserHistory();

setupAxios(store, history);

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  i18n.on('initialized', () => {
    root.render(
      <StoreProvider store={store}>
        <App history={history} />
      </StoreProvider>
    );
  });
};

renderApp();
